/* eslint-disable react/destructuring-assignment */
import React from 'react'
import { observeImmutable } from '@core/Components/HOCs/observe'
import { PopupNoticeBox } from '@core/Components/PopupNoticeBox'
import { appHistory } from '@core/Utils/routing/history'
import {
  state$ as reverificationState$,
  ReverificationCompleted,
  ReverificationStateRecord,
} from './../../driver'
import {
  state$ as contactDetailsState$,
  ContactDetailsStateRecord,
} from '@core/Areas/ContactDetails/driver'

interface ReverificationCompleteMessageProps {
  isDesktop: boolean
  isReverificationSuccess: boolean
  isReverificationFailed?: boolean
  isReverificationCompleted: boolean
  navigateToHistoryBack?: boolean
}

export const ReverificationComplete = observeImmutable<
  ReverificationStateRecord,
  { isDesktop: boolean }
>(reverificationState$, ({ record, isDesktop }) => {
  const { isReverificationSuccess, isReverificationFailed, isReverificationCompleted } = record
  return (
    <ReverificationCompleteMessage
      isDesktop={isDesktop}
      isReverificationSuccess={isReverificationSuccess}
      isReverificationFailed={isReverificationFailed}
      isReverificationCompleted={isReverificationCompleted}
    />
  )
})

export const ContactDetailsReverificationSuccess = observeImmutable<
  ContactDetailsStateRecord,
  { navigateToHistoryBack?: boolean; isDesktop: boolean }
>(contactDetailsState$, ({ record, navigateToHistoryBack, isDesktop }) => {
  const { isReverificationSuccess } = record
  return (
    <ReverificationCompleteMessage
      isDesktop={isDesktop}
      isReverificationSuccess={!!isReverificationSuccess}
      isReverificationCompleted={false}
      navigateToHistoryBack={navigateToHistoryBack}
    />
  )
})

export class ReverificationCompleteMessage extends React.Component<ReverificationCompleteMessageProps> {
  private reverificationCompleteRef: HTMLElement | null = null

  public onClose = () => {
    ReverificationCompleted()
    if (this.props.navigateToHistoryBack) {
      if (this.props.isDesktop) {
        window.history.back()
      } else {
        appHistory.back()
      }
    }
  }

  public componentDidMount() {
    // on mount scroll to message
    if (this.reverificationCompleteRef) {
      window.scrollTo(0, -this.reverificationCompleteRef.offsetTop)
    }
  }

  public render() {
    if (!this.props.isReverificationSuccess && !this.props.isReverificationFailed) {
      return null
    }

    if (this.props.isReverificationCompleted) {
      return null
    }

    const message = this.props.isReverificationSuccess
      ? 'Re-verification was successful'
      : 'Re-verification was unsuccessful please try again later.'

    const subtitle = this.props.isReverificationSuccess ? 'Thank you!' : ''

    return (
      <div
        ref={node => {
          this.reverificationCompleteRef = node
        }}
      >
        <PopupNoticeBox
          noticeBoxType={this.props.isReverificationSuccess ? 'Success' : 'Error'}
          title={message}
          subtitle={subtitle}
          closeText='continue'
          onClose={this.onClose}
        />
      </div>
    )
  }
}
